import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { Form, Field } from "react-final-form";
import Moment from "moment";
import { createBulkPlans } from 'actions/plans';
import { saveBlocksOnReference } from 'actions/blocks';
import { isUserTeacher } from "helpers/user";
import { connect } from "react-redux";
import { Expandable, List } from "UI";
import { Editor } from "UI/Inputs";
import { Button, translate } from '@haldor/ui';
import DatePickerFromTo from "../Partials/DatePickerFromTo";
import MultipleSectionSelector from "../Partials/MultipleSectionSelector";
import SearchPreschoolGoals from "../SearchPreschoolGoals";
import TeacherAdjustments from "containers/AdditionalAdjustments/Display/TeacherAdjustments";
import BlockEditor from 'components/BlockEditor';

var MultiplePreschoolPlanForms = /*#__PURE__*/function (_Component) {
  _inherits(MultiplePreschoolPlanForms, _Component);

  var _super = _createSuper(MultiplePreschoolPlanForms);

  function MultiplePreschoolPlanForms(props) {
    var _this;

    _classCallCheck(this, MultiplePreschoolPlanForms);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (typeof value !== "undefined" && value !== "") {
        if (value.length > 199) {
          // Field failed validation, return error for this field (String)
          return _this.props.translate("field-max-200-chars");
        } // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string and not over 200 characters


        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate("field-needs-input");
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        var _this$state = _this.state,
            selectedGoals = _this$state.selectedGoals,
            dateStart = _this$state.dateStart,
            dateEnd = _this$state.dateEnd,
            sections = _this$state.sections;
        var progress = values.progress,
            evaluation = values.evaluation;
        var attachedFiles = [];
        var blocks = [];

        if (values.blocks != null) {
          blocks = _toConsumableArray(values.blocks);
        }

        blocks.forEach(function (block) {
          if (block.type == 'Haldor.Blocks.Assignment') {
            if (block.resources != null) {
              var resources = [];
              block.resources.forEach(function (resource) {
                resources.push({
                  id: resource.id,
                  '@odata.type': resource['@odata.type']
                });
              });
              block.resources = resources;
            }
          }

          return block;
        });
        delete values.blocks;
        delete values.progress;
        delete values.evaluation;

        if (_this.state.attachedFiles != null && _this.state.attachedFiles.length > 0) {
          attachedFiles = _this.state.attachedFiles;
        }

        values.fields = [{
          title: "evaluation-and-analysis",
          content: evaluation,
          type: "MULTILINETEXT",
          roles: [{
            roleID: "Teacher"
          }]
        }, {
          title: "heres-how-we-work",
          content: progress,
          type: "MULTILINETEXT",
          roles: [{
            roleID: "Teacher"
          }]
        }];
        /* Add custom inputs to the values object that redux form creates */

        values.associatedGoals = selectedGoals;
        values.timeStart = dateStart;
        values.timeEnd = dateEnd;

        if (values.status == null) {
          values.status = "PLANNING_OPEN";
        }

        values.sections = sections;
        values.associatedMatrices = [];
        values.matrix = null;
        values.attachedFiles = attachedFiles;

        if (_this.state.newDocuments != null && _this.state.newDocuments.length > 0) {
          values.attachedFiles = [].concat(_toConsumableArray(values.attachedFiles), _toConsumableArray(_this.state.newDocuments));
        }
        /* Make request */


        var that = _assertThisInitialized(_this);

        _this.props.createBulkPlans(values).then(function () {
          var promises = [];

          if (_this.props.createdPlans != null && blocks != null && blocks.length > 0) {
            _this.props.createdPlans.forEach(function (createdPlan) {
              promises.push(new Promise(function (resolve) {
                _this.props.saveBlocksOnReference(blocks, createdPlan.id, 'PLAN').then(function () {
                  resolve(1);
                });
              }));
            });
          }

          Promise.all(promises).then(function () {
            that.props.onAbort(true, true);
            resolve(1);
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGoalsChange", function (selectedGoals) {
      _this.setState({
        selectedGoals: selectedGoals
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectDocument", function (files) {
      _this.setState({
        newDocuments: files
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (dates) {
      _this.setState({
        dateStart: dates.start,
        dateEnd: dates.end
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSectionsChange", function (state) {
      _this.setState({
        sections: state
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          type = _ref.type,
          placeholder = _ref.placeholder,
          _ref$meta = _ref.meta,
          touched = _ref$meta.touched,
          error = _ref$meta.error,
          warning = _ref$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({
        placeholder: placeholder || label,
        type: type,
        style: touched && error ? {
          border: "1px solid red"
        } : {}
      }, input)), touched && (error && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: "1rem",
          color: "red"
        }
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: "1rem",
          color: "red"
        }
      }, warning)));
    });

    _this.state = {
      selectedGoals: [],
      attachedFiles: [],
      dateStart: null,
      dateEnd: null,
      sections: []
    };
    return _this;
  }
  /* Redux form functions */


  _createClass(MultiplePreschoolPlanForms, [{
    key: "render",
    value:
    /* Begin render */
    function render() {
      var _this2 = this;

      var groupId = null;

      if (this.state.sections.length == 1) {
        groupId = this.state.sections[0].id;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-container form-create_task"
      }, /*#__PURE__*/React.createElement(Form, {
        onSubmit: this.submit,
        mutators: {
          setStatusDraft: function setStatusDraft(args, state, utils) {
            utils.changeValue(state, 'status', function () {
              return 'PLANNING_DRAFT';
            });
          },
          setStatusOpen: function setStatusOpen(args, state, utils) {
            utils.changeValue(state, 'status', function () {
              return 'PLANNING_OPEN';
            });
          }
        },
        render: function render(_ref2) {
          var handleSubmit = _ref2.handleSubmit,
              submitting = _ref2.submitting,
              valid = _ref2.valid,
              form = _ref2.form;
          return /*#__PURE__*/React.createElement("form", {
            onSubmit: handleSubmit,
            className: "form form-component"
          }, submitting ? /*#__PURE__*/React.createElement("div", {
            className: "is_sending"
          }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
            className: "loading-spinner"
          }))) : null, /*#__PURE__*/React.createElement(Expandable, {
            contentStyles: {
              padding: "1em 0rem"
            },
            contentStylesClosed: {
              padding: "0"
            },
            headerStyles: _this2.state.error != null ? {
              border: "1px solid red"
            } : {},
            whiteBackground: true,
            title: _this2.props.translate("choose-groups"),
            open: true,
            ignorePropsUpdate: true
          }, /*#__PURE__*/React.createElement(List, {
            style: {
              border: "0",
              margin: "0",
              boxShadow: "0"
            }
          }, /*#__PURE__*/React.createElement(MultipleSectionSelector, {
            onChange: _this2.onSectionsChange
          }))), /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement(DatePickerFromTo, {
            type: "plan",
            onChange: _this2.onDateChange
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-row input"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate("title"), "*"), /*#__PURE__*/React.createElement(Field, {
            component: _this2.renderInput,
            type: "text",
            name: "title",
            placeholder: _this2.props.translate("title"),
            validate: _this2.required
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate("select-goals")), /*#__PURE__*/React.createElement(SearchPreschoolGoals, {
            selectedGoals: null,
            onChange: _this2.onGoalsChange
          })), isUserTeacher(_this2.props.currentUser) ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement(Field, {
            component: Editor,
            name: "evaluation",
            label: "Utv\xE4rdering och analys",
            placeholder: "Utv\xE4rdering och analys",
            translate: _this2.props.translate
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement(Field, {
            component: Editor,
            name: "progress",
            label: "S\xE5 h\xE4r jobbar vi vidare",
            placeholder: "S\xE5 h\xE4r jobbar vi vidare",
            translate: _this2.props.translate
          }))) : null, /*#__PURE__*/React.createElement("div", {
            className: "form-divider"
          }), _this2.props.services.additionalAdjustments ? /*#__PURE__*/React.createElement(Expandable, {
            title: _this2.props.translate("additional-adjustments")
          }, /*#__PURE__*/React.createElement(TeacherAdjustments, {
            disableCommenting: true,
            groupId: groupId
          })) : null, /*#__PURE__*/React.createElement(Field, {
            component: BlockEditor,
            name: "blocks"
          }), /*#__PURE__*/React.createElement("div", {
            className: "form-divider"
          }), /*#__PURE__*/React.createElement("div", {
            className: "form-row spacing submit"
          }, /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick(e) {
              e.preventDefault();
              form.mutators.setStatusOpen();
              form.submit();
            },
            disabled: submitting || !valid || _this2.state.sections.length == 0
          }, _this2.props.translate("publish")), /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick(e) {
              e.preventDefault();
              form.mutators.setStatusDraft();
              form.submit();
            },
            type: "secondary",
            disabled: submitting || !valid || _this2.state.sections.length == 0
          }, _this2.props.translate("save-draft")), /*#__PURE__*/React.createElement("div", {
            className: "align-right"
          }, /*#__PURE__*/React.createElement(Button, {
            type: "secondary",
            onClick: function onClick(e) {
              e.preventDefault();

              _this2.props.onAbort(false);
            }
          }, _this2.props.translate("Cancel")))));
        }
      }));
    }
  }]);

  return MultiplePreschoolPlanForms;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    sections: state.sections.educationGroups,
    currentUser: state.user.currentUser,
    services: state.Services.availableServices,
    createdPlans: state.planning.createdPlans
  };
}

export default connect(mapStateToProps, {
  createBulkPlans: createBulkPlans,
  saveBlocksOnReference: saveBlocksOnReference
})(MultiplePreschoolPlanForms);